import { render, staticRenderFns } from "./MobilePayment.vue?vue&type=template&id=221004ee&"
import script from "./MobilePayment.vue?vue&type=script&lang=ts&"
export * from "./MobilePayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports